export const selectAllBackgrounds = state => state.backgrounds;
